import { Action } from '@ngrx/store';

export class UserTagAction implements Action {

    public static getUserTag = '[UserTag] get_user_tag';
    public static getUserTagError = '[UserTag] ge_user_tag_error';
    public static getUserTagSuccess = '[UserTag] get_user_tag_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
